import request from '@/utils/request.js'
import Utils from '@/utils/index.js'


const basePath = '/Function/Auth/';

const state = {
  session: {}
};

const mutations = {
  setSession(state, view) {
    state.session = view;
  }
};

const actions = {
  GetSession({commit}, view) {
    return new Promise((resolve, reject) => {
      if (view == null) {
        view = {
          params: {}
        };
      } else {
        if (view.params == null) {
          view.params = {};
        }
      }
      //
      if (view.params.SysUserRole_id == null) {
        var SysUserRole_id = Utils.GetQueryString('SysUserRole_id');
        if (SysUserRole_id != null) {
          view.params.SysUserRole_id = SysUserRole_id;
        }
      }
      return request.PromiseCall(basePath, 'GetSession', view).then((res) => {
        commit('setSession', res);
        resolve(res);
      }).catch((msg) => {
        reject(msg);
      });
    });
  },
  //=====================================================
  LoginByMobilePhone({commit}, view) {
    return request.PromiseCall(basePath, 'LoginByMobilePhone', view);
  },
  SendVerVode({commit}, view) {
    return request.PromiseCall(basePath, 'SendVerVode', view);
  },
  ChangeSysUserRole({commit}, view) {
    return request.PromiseCall(basePath, 'ChangeSysUserRole', view);
  }, Logout({commit}, view) {
    return request.PromiseCall(basePath, 'Logout', view);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/Function/Auth/index.js